import React, { Component } from "react";
import { Grid, Row, Col, Modal } from "react-bootstrap";
import Pagination from "../../../components/Common/pagination";
import Select from "../../../components/Common/select";
import * as itemGroupMapService from "../../../services/itemGroupMapServices";
// import Checkbox from "../../../components/Common/checkbox";
// import HomeBakMasukSearch from "../bakmasuk/homeBakMasukSearch";
// import Input from "../../../components/Common/input";
import RekapQcGroupTable from "./rekapQcGroupTable";
import RekapQcSearch from "./rekapQcSearch";
import Input from "../../../components/Common/input";

// var XLSX = require("xlsx");
var base64 = require("base-64");

class RekapQcGroup extends Component {
  state = {
    items: [],
    limit: 10,
    currentPage: 1,
    maxPage: 0,
    offset: 0,
    order: "id_qc_group_item",
    type: "asc",
    search: {
      group: "",
      dateFrom: "",
      dateTo: ""
    },
    drawing:[],
    hideSearch: true,
    show: [{ limit: 10 }, { limit: 25 }, { limit: 50 }, { limit: 100 }],
    sortColumn: { path: "id_qc_group_item", order: "asc" },
    selectedItem: [],
    openModalDelete: false,
    status: 0,
    openModalUpload: false,
    selectedFile: null,
    allowFile: false,
    isOpen: false,
    image: "",
    allowFile: false,
    uploading: false,
    stateModalUpload: false,
    openModalUpdate: false,
    openModalPrint: false,
    itemSupplier: [],
    searchDrawing: {
      code: "",
      supplier_name: "",
      customer_name: "",
      code_supplier: "",
      customer_code: "",
      drawing_category: "",
      description: ""
    },
    openModalDetail:false,
    openModalDetailCustomer:false,
    selectedIdItem: -1,
    tDimension: 0,
    tSurface: 0,
    tStuffing: 0
  };
  onSort = (sortColumn) => {
    if (this.mount) {
      this.setState(
        { sortColumn, order: sortColumn.path, type: sortColumn.order },
        () => {
          this.getDataItem();
        }
      );
    }
  };
  handleChangePage = (page) => {
    const { maxPage, limit } = this.state;
    if (this.mount) {
      if (page > 0 && page < parseInt(maxPage, 10) + 1) {
        this.setState({ currentPage: page, offset: (page - 1) * limit }, () => {
          this.getDataItem();
        });
      }
    }
  };
  handleChangeLimit = ({ currentTarget: input }) => {
    const val = input.value;
    if (this.mount) {
      this.setState({ limit: val, currentPage: 1, offset: 0 }, () => {
        this.getDataItem();
      });
    }
  };
  componentDidMount() {
    this.mount = true;
    this.baseSearch = this.state.search;
    if (this.props.location.search) {
      this.initSearch1();
    } else {
      this.getDataItem();
    }
  }
  componentWillReceiveProps() {
    setTimeout(() => {
      this.initSearch1();
    }, 1000);
  }
  initSearch1 = () => {
    if (this.props.location.search) {
      let tempSearch = decodeURI(this.props.location.search).substring(7);
      const newState = JSON.parse(base64.decode(tempSearch));
      this.setState(newState, () => {
        this.fetchData();
      });
    }
  };

  componentWillUnmount() {
    this.mount = false;
  }

  fetchData = async () => {
    const { limit, offset, order, type, search } = this.state;
    itemGroupMapService.getDataReportQc(search, limit, offset, order, type).then((data) => {
      console.log(data);
      // let temp = data.bak
      //   ? data.bak.map(bak => {
      //       return {
      //         ...bak,
      //         selected: this.getPrintedIdx(bak) >= 0 ? true : false
      //       };
      //     })
      //   : [];
      this.setState({
        items: data.item,
        maxPage: data.page,
        tDimension: data.tDimension,
      });
    });
  };
  getDataItem = async () => {
    const { limit, offset, order, type, search } = this.state;
    itemGroupMapService.getDataReportQc(search, limit, offset, order, type).then((data) => {
      console.log(data);
      // let temp = data.bak
      //   ? data.bak.map(bak => {
      //       return {
      //         ...bak,
      //         selected: this.getPrintedIdx(bak) >= 0 ? true : false
      //       };
      //     })
      //   : [];
      this.setState(
        {
          items: [],
          maxPage: data.page,
        },
        () => {
          this.props.history.push(
            "/group-report/?query=" +
              base64.encode(unescape(JSON.stringify(this.state)))
          );
        }
      );
    });
  };

  toggleSearch = () => {
    const { hideSearch, search } = this.state;

    this.setState({
      hideSearch: !hideSearch,
      search: hideSearch ? search : this.baseSearch,
    });
  };

  handleChangeDate = (e, target) => {
    if (typeof e === "object") {
      let datetime = e.format("YYYY-MM-DD");
      const search = { ...this.state.search };
      search[target] = datetime;
      if (this.mount) {
        this.setState({ search });
      }
    } else {
      const search = { ...this.state.search };
      search[target] = "";
      if (this.mount) {
        this.setState({ search });
      }
    }
  };
  handleChange = ({ currentTarget: input }) => {
    const search = { ...this.state.search };
    search[input.name] = input.value;
    if (this.mount) {
      this.setState({ search });
    }
  };
  handleSubmitSearch = () => {
    this.setState({ currentPage: 1, offset: 0 }, () => {
      this.getDataItem();
    });
  };
  checkExt(val) {
    let temp = val.substring(val.length - 4);
    temp = temp.replace(".", "");
    let acceptable = false;
    if (
      temp.toLowerCase() === "jpg" ||
      temp.toLowerCase() === "png" ||
      temp.toLowerCase() === "jpeg" ||
      temp.toLowerCase() === "pdf"
    ) {
      acceptable = true;
    }
    return acceptable;
  }
  handleSelectedFile = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      allowFile: this.checkExt(event.target.files[0].name),
    });
  };
  handleShowImage = (image) => {
    if (this.mount)
      this.setState({ image, isOpen: true, openModalUpload: false });
  };
  closeLightBox = () => {
    const { stateModalUpload } = this.state;
    if (this.mount)
      this.setState({ isOpen: false, openModalUpload: stateModalUpload });
  };
  isPdf(val) {
    let pdf = false;
    if (val) {
      let temp = val.substring(val.length - 4);
      temp = temp.replace(".", "");
      if (temp.toLowerCase() === "pdf") {
        pdf = true;
      }
    }
    return pdf;
  }
  gotoDimension = async (item) =>{
      if(item.qc_dimension>0){
        localStorage.setItem('dgGroup',item.group);
        localStorage.setItem('dgStuffing',item.stuffing_date);
        this.props.history.push(
          "/qc/group-item"
      );
    }
  }
  render() {
    const {
      items,
      show,
      currentPage,
      maxPage,
      limit,
      sortColumn,
      search,
      hideSearch,
      openModalDelete,
      isOpen,
      image,
      uploading,
      itemSupplier,
      openModalPrint,
      searchDrawing,
      openModalDetail,
      openModalDetailCustomer,
      drawing,
      tDimension,
      tSurface,
      tStuffing
    } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <h3
                style={{ cursor: "pointer" }}
                onClick={() => this.toggleSearch()}
              >
                {hideSearch ? (
                  <span>Show Search</span>
                ) : (
                  <span>Hide Search</span>
                )}
              </h3>
              {!hideSearch ? (
                <RekapQcSearch
                  search={search}
                  handleChange={this.handleChange}
                  handleSubmitSearch={this.handleSubmitSearch}
                />
              ) : null}
              <div className="card">
                <div className="content">
                  <Row>
                    <Col md={3}>
                      {/* <div className="form-group">
                        <label>Show</label>
                        <InputGroup style={{ maxWidth: "200px" }}> */}
                      <Select
                        label="Show"
                        onChange={this.handleChangeLimit}
                        options={show}
                        optionValue="limit"
                        optionLabel="limit"
                        name="limit"
                        value={limit}
                      />
                      {/* 
                          <InputGroup.Addon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.setState({ openModalFilter: true })
                            }
                          >
                            <i
                              className="fa fa-cog"
                              style={{ fontSize: "25px" }}
                            />
                          </InputGroup.Addon> */}
                      {/* </InputGroup>
                      </div> */}
                    </Col>
                    <Col md={6}></Col>
                    <Col md={3}>
                      <Input
                        disabled={true}
                        value={tDimension}
                        format="number"
                        name="total_qc_dimension"
                        label="Total QC Dimension"
                      />
                    </Col>
                    
                    <Col md={12} style={{ overflow: "auto" }}>
                      <RekapQcGroupTable
                        items={items}
                        onSort={this.onSort}
                        sortColumn={sortColumn}
                        currentPage={currentPage}
                        limit={limit}
                        gotoDimension={this.gotoDimension}
                      />
                    </Col>
                    <Col md={12} style={{ textAlign: "center" }}>
                      <Pagination
                        onPageChange={this.handleChangePage}
                        currentPage={currentPage}
                        pagesCount={maxPage}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default RekapQcGroup;



// WEBPACK FOOTER //
// ./src/views/qc/report/rekapGroup.jsx